import React, { memo, useCallback } from 'react'
import fetchAPI from '../../../../../lib/utils/fetch-api'
import { ExportExcelButton, format2Print } from 'src/react-app/components/v2/export-excel-button'

export interface AppealsPrintButtonProps {
  path: string,
  columns: any[],
}

export const ClaimsPrintButton: React.FC<AppealsPrintButtonProps> = memo((props) => {
  const { path, columns } = props

  const handlePrintClick = useCallback(async () => {
    console.log('handlePrintClick')
    try {
      const response = await fetchAPI(path)
      const data = response.data
      if (!data) {
        return
      }
      console.log({ data })

      const viewColumnNames = columns.map(column => column.dataIndex)
      const count = data.length

      for (let i = 0; i < count; i++) {
        let keys = Object.keys(data[i])
        keys.forEach(key => {
          if (!viewColumnNames.includes(key)) {
            return
          }
          if (key === 'stage') {
            data[i][key] = data[i][key]?.name
            return
          }
          if (typeof data[i][key] === 'string' && data[i][key].includes('.') && !isNaN(data[i][key])) {
            data[i][key] = data[i][key].replace('.', ',')
          }

          data[i][key] = format2Print(key, data[i][key])
        })
      }

      return data
    } catch (e) {
      console.log('handlePrintClick', e)
    }
  }, [columns, path])

  return (
    <ExportExcelButton
      fileName={'Рекламации'}
      path={path}
      columns={columns}
      onPrintClick={handlePrintClick}
    />
  )
})
